module.exports = __webpack_public_path__ + "img/small-13.088980ff.jpg";